function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
var _hashStoreAttribute = /*#__PURE__*/new WeakMap();
var _lastVisitedUrl = /*#__PURE__*/new WeakMap();
var _shouldScrollToTop = /*#__PURE__*/new WeakMap();
var _ScrollController_brand = /*#__PURE__*/new WeakSet();
export var ScrollController = /*#__PURE__*/function () {
  function ScrollController() {
    _classCallCheck(this, ScrollController);
    _classPrivateMethodInitSpec(this, _ScrollController_brand);
    // @todo write e2e tests for hash position restoring
    _classPrivateFieldInitSpec(this, _hashStoreAttribute, 'ilcTempStoredHash');
    _classPrivateFieldInitSpec(this, _lastVisitedUrl, this.location.pathname);
    _classPrivateFieldInitSpec(this, _shouldScrollToTop, true);
  }
  return _createClass(ScrollController, [{
    key: "location",
    get: function get() {
      return window.location;
    }
  }, {
    key: "onEveryRouteChange",
    value: function onEveryRouteChange() {
      _classPrivateFieldSet(_shouldScrollToTop, this, _classPrivateFieldGet(_lastVisitedUrl, this).toLowerCase() !== this.location.pathname.toLowerCase());
      _classPrivateFieldSet(_lastVisitedUrl, this, this.location.pathname);
    }
  }, {
    key: "store",
    value: function store() {
      if (this.location.hash) {
        var node = _assertClassBrand(_ScrollController_brand, this, _getHashStoreNode).call(this);
        var hashValue = _assertClassBrand(_ScrollController_brand, this, _getHashValue).call(this);
        node.setAttribute(_classPrivateFieldGet(_hashStoreAttribute, this), hashValue);
      }
    }
  }, {
    key: "restore",
    value: function restore() {
      var node = _assertClassBrand(_ScrollController_brand, this, _getHashStoreNode).call(this);
      // @todo: looks like it never used so storing is useless
      node.removeAttribute(_classPrivateFieldGet(_hashStoreAttribute, this));
      _assertClassBrand(_ScrollController_brand, this, _restoreScrollOnNavigation).call(this);
    }
  }]);
}();
function _getHashStoreNode() {
  return document.body;
}
function _restoreScrollOnNavigation() {
  var scrollToElement;
  if (this.location.hash) {
    scrollToElement = document.getElementById(_assertClassBrand(_ScrollController_brand, this, _getHashValue).call(this));
  }
  if (scrollToElement) {
    scrollToElement.scrollIntoView();
    return;
  }
  if (_classPrivateFieldGet(_shouldScrollToTop, this)) {
    window.scroll(0, 0);
  }
}
function _getHashValue() {
  try {
    return decodeURIComponent(this.location.hash.slice(1));
  } catch (error) {
    // @todo handle an error the hash should not be read if it not exists
    return false;
  }
}